// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { billingAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay";
import { billingAndShippingAddressStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo";
import { shippingAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { checkoutContainer } from "@mcmc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmit.helper";
import { sectionSubTitleStyle } from "@mcmc/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

const displayNone: InjectableCss = {
    css: css`
        display: none;
    `,
};

shippingAddressInfoDisplayStyles.heading = sectionSubTitleStyle;
shippingAddressInfoDisplayStyles.editLink = displayNone;

billingAddressInfoDisplayStyles.heading = sectionSubTitleStyle;
billingAddressInfoDisplayStyles.editLink = displayNone;

billingAndShippingAddressStyles.carrierGridItem = displayNone;
billingAndShippingAddressStyles.deliveryDateGridItem = displayNone;
billingAndShippingAddressStyles.shippingServiceGridItem = displayNone;
billingAndShippingAddressStyles.container = {
    gap: checkoutContainer.gap,
    offsetCss: css`
        flex-direction: row-reverse;
    `,
};
billingAndShippingAddressStyles.billingAddressGridItem = billingAndShippingAddressStyles.shippingAddressGridItem = {
    width: [12, 6, 6, 6, 6],
};
